<template>
  <div :class="$style.root">
    <img
      src="/figma/tire-wheel-double-composition.svg"
      :class="$style.image"
      alt=""
    />
    <svg
      :class="$style.overlay"
      viewBox="0 0 512 150"
      aria-hidden="true"
    >
      <defs>
        <path :id="leftPathId" d="M31 100A124 124 0 0 1 225 100" />
        <path :id="rightPathId" d="M287 100A124 124 0 0 1 481 100" />
      </defs>

      <text :class="$style.primaryText">
        <textPath
          :href="`#${leftPathId}`"
          startOffset="50%"
          text-anchor="middle"
          dy="26"
        >
          {{ primaryLabel }}
        </textPath>
      </text>

      <text :class="[$style.secondaryText, { [$style.secondaryFilled]: secondaryLabel }]">
        <textPath
          :href="`#${rightPathId}`"
          startOffset="50%"
          text-anchor="middle"
          dy="26"
        >
          {{ secondaryLabel || secondaryPlaceholder }}
        </textPath>
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: "TireSizeWheelWide",
  props: {
    primaryLabel: {
      type: String,
      default: "",
    },
    secondaryLabel: {
      type: String,
      default: "",
    },
    secondaryPlaceholder: {
      type: String,
      default: "XX/XX RXX",
    },
  },
  computed: {
    leftPathId() {
      return `tire-wheel-wide-left-${this._uid}`;
    },
    rightPathId() {
      return `tire-wheel-wide-right-${this._uid}`;
    },
  },
};
</script>

<style lang="scss" module>
.root {
  position: relative;
  width: 100%;
  max-width: 33.5rem;
  margin: 0 auto;
  overflow: visible;
}

.image {
  width: 100%;
  display: block;
  position: relative;
  z-index: 0;
}

.overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: visible;
  z-index: 1;
}

.primaryText,
.secondaryText {
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
}

.primaryText {
  fill: $t-white;
}

.secondaryText {
  fill: rgba(255, 255, 255, 0.16);
}

.secondaryFilled {
  fill: $t-white;
}
</style>
